const LOCALES = { it: "it-IT", en: "en-GB", es: "es-ES" };

function loc(lang) {
  return LOCALES[lang] || LOCALES.it;
}

export function formatDate(iso, lang = "it") {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toLocaleDateString(loc(lang), { day: "numeric", month: "long", year: "numeric" });
}

export function formatDateTime(iso, lang = "it") {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const date = d.toLocaleDateString(loc(lang), { day: "numeric", month: "long", year: "numeric" });
  const time = d.toLocaleTimeString(loc(lang), { hour: "2-digit", minute: "2-digit" });
  return `${date} · ${time}`;
}

export function formatDateShort(iso, lang = "it") {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const mon = d.toLocaleDateString(loc(lang), { month: "short" }).replace(".", "").toUpperCase();
  return `${day} ${mon} ${d.getFullYear()}`;
}

export function isPast(iso) {
  if (!iso) return false;
  const d = new Date(iso);
  if (isNaN(d)) return false;
  return d.getTime() < Date.now();
}

export function getCountdownParts(iso) {
  const target = new Date(iso).getTime();
  const diff = target - Date.now();
  if (isNaN(target) || diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, ended: true };
  }
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds, ended: false };
}
